









































import {Component, Prop, Vue} from 'vue-property-decorator'
import {Game} from "@/models/Game";

@Component
export default class ScoreBoard extends Vue {

    @Prop()
    showScoreBoard: boolean;

    @Prop()
    game: Game;

    private headers = [
        {text: 'Name', value: 'name'},
        {text: 'Punkte', value: 'score'},
    ]

    private closeScoreBoard() {
        this.$emit('close-score-board');
    }

}
